import React, { useContext, useEffect, useRef, useState } from 'react'
import { DotsHorizontal, Loading, Picture } from 'components/misc/Icons'
import { useTranslation } from "react-i18next";
import { AppState } from 'App';

import ModalEmoji from 'components/modals/ModalEmoji'

const SidebarButton = ({tag, icons, tagCounts }) => {

    const {t, i18n} = useTranslation('common');

    const [appState, setAppState] = useContext(AppState)

    const node = useRef();
    const [updateTag, setUpdateTag] = useState()
    const [showIcon, setShowIcon] = useState(false)
    const [showOptions, setShowOptions] = useState(false)
    const [modalEmojiOpen, setModalEmojiOpen] = useState(false)

    const handleClickOutside = e => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        setShowOptions(false);
    };

    useEffect(() => {
        if (showOptions) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showOptions]);

    return (
        <>
        <button
            key={tag}
            ref={node}
            onMouseOver={() => setShowIcon(true)}
            onMouseLeave={() => setShowIcon(false)}
            onClick={() => setAppState(prevState => ({...prevState,tagContext:tag}))}
            className="relative flex flex-row items-center justify-between h-10 p-2 border border-transparent rounded-lg w-52 dark:bg-itemdark hover:bg-itemlight hover:border hover:border-borderlighthover focus:bg-itemlight focus:border focus:border-borderlight focus:outline-none dark:hover:bg-itemdark dark:hover:border-borderdark dark:focus:border-borderdark dark:focus:bg-itemdark bg-itemlight border-borderlight dark:border-borderdark">
            <div className="flex items-center">
                {icons!==null && icons!==undefined && (`${tag}` in icons) ?
                <span role="img" aria-label="star" className="text-2xl">{icons[tag]}</span>
                :
                <span role="img" aria-label="star" className="text-2xl">➕</span>
                }
                <span className="ml-2 font-light text-left capitalize truncate w-34 dark:text-textdark text-textlight">{tag}</span>
                {appState.loadingContext & appState.tagContext===tag ? <span><Loading width={4} height={4} stroke={3} /></span> : null}
            </div>
            <div className="flex items-center">
                <span id={tag} className="text-xs font-light dark:text-textdarksubtle text-textlightsubtle">{tagCounts[tag]}</span>
            </div>

            {showIcon ? (
                <div
                    onClick={(e) => e.stopPropagation() | setShowOptions(!showOptions) | setUpdateTag(tag)}
                    className="absolute top-0 right-0 w-8 h-8 mt-1 mr-1 rounded-lg bg-itemlight dark:bg-itemdark dark:text-textdark text-textlight hover:bg-borderlight dark:hover:bg-borderdark dark:border-borderdark">
                    <DotsHorizontal/>
                </div>
            ) : (
                null
            )}

            {showOptions ? (
                <div className="absolute w-48 py-1 mt-8 ml-48 border rounded-lg shadow bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark z-1100">
                    <div
                        onClick={(e) => e.stopPropagation() | setModalEmojiOpen(true)}
                        className="flex items-center w-full h-8 px-2 transition-colors duration-200 transform dark:bg-itemdark hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                        <Picture width="6" height="6" stroke="1"/>
                        <span className="inline-block ml-2 text-sm">Change icon</span>
                    </div>
                </div>
            ) : (
                null
            )}
        </button>
        <ModalEmoji open={modalEmojiOpen} onClose={() => setModalEmojiOpen(false)} tag={updateTag} />
        </>
    )
}

export default SidebarButton
